import { render, staticRenderFns } from "./Premiacoes.vue?vue&type=template&id=55df7b6c&scoped=true"
import script from "./Premiacoes.vue?vue&type=script&lang=js"
export * from "./Premiacoes.vue?vue&type=script&lang=js"
import style0 from "./Premiacoes.vue?vue&type=style&index=0&id=55df7b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df7b6c",
  null
  
)

export default component.exports